import { isString as i } from "../value/is.js";
const s = (...t) => {
  const [e] = t, n = (t.length >= 2 ? new Date(...t) : e instanceof Date ? e : new Date(i(e) || Number.isFinite(e) ? e : void 0)).getTime();
  return Number.isFinite(n) ? n : void 0;
};
export {
  s as parseDate
};
